import type { ProvisionalSubmitValues, ReclassifyTradeType } from './provisional-invoice-schema';

type ReclassifyValues = Pick<
  ProvisionalSubmitValues,
  'reclassify_to_invoice_type' | 'reclassification_reason'
>;

// Folds the reclassify selection into an edit payload. A re-type only happens
// when the chosen target differs from the invoice's current type; otherwise the
// base payload is returned untouched so a plain edit never touches the type.
// The backend re-types linked payments and appends the reason to remarks.
export function withReclassification(
  base: Record<string, unknown>,
  values: ReclassifyValues,
  currentType: ReclassifyTradeType,
): Record<string, unknown> {
  const target = values.reclassify_to_invoice_type;
  if (target === undefined || target === currentType) return base;
  const out: Record<string, unknown> = { ...base, invoice_type: target };
  if (values.reclassification_reason !== undefined) {
    out['reclassification_reason'] = values.reclassification_reason;
  }
  return out;
}

// The schema enforces a reason of ≥5 chars when one is present, but "a reason is
// required once the type actually changed" depends on the current type, which
// the schema can't see. The dialog calls this to block submit and flag the
// field when a reclassification is requested without a reason.
export function reclassificationReasonMissing(
  values: ReclassifyValues,
  currentType: ReclassifyTradeType,
): boolean {
  const target = values.reclassify_to_invoice_type;
  return (
    target !== undefined && target !== currentType && values.reclassification_reason === undefined
  );
}
